/* eslint-disable no-confusing-arrow */
import React, { useState } from 'react';
import {
    Table, Header, Modal, Grid
} from 'semantic-ui-react';
import SpecialsTable from './SpecialsTable';
import SpecialsForm from './SpecialsForm';
import GrowthRateTable from './GrowthRateTable';
import GrowthRateForm from './GrowthRateForm';
import GroupingsTable from './GroupingsTable';
import UnitTypesTable from './UnitTypesTable';
import UnitTypesForm from './UnitTypesForm';
import { useUnitTypes } from '~/unit-types';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useMeasurements } from '~/measurements';
import Button from '@mui/material/Button';
import Swal from '#/swal';
import { api } from '#/apis';


const styles = {
    root: {
        margin: '10px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px',
        alignItems: 'center',
        paddingTop: '20px'
    },
    specialsTitle: {
        textAlign: 'center'
    },
    specialsRow: {
        padding: '0 50px 0 50px'
    }
};

const run = async (tab, property_id = null) => {

    let endpoint = `/scripts/${tab}`;

    if (property_id) {

        endpoint += `/${property_id}`;
    }

    await api.post(endpoint);
};


export const UnitTypesView = props => {

    const [specialsModalOpen, setSpecialsModalOpen] = useState(false);
    const [grModalOpen, setGRModalOpen] = useState(false);
    const [unitTypesModalOpen, setUnitTypesModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState(null);


    const {
        data, isLoading, isFetching, isError
    } = useUnitTypes(props.match.params.property_id);

    const {
        data: fetchMeasurements
    } = useMeasurements(props.match.params.property_id);


    const handlerRunSnapshot = async property => {

        if (property){
            const result = await Swal.fire.warning({
                text: `This will run the Snapshot for the property ${property.name}`
            });

            if (result.value) run('snapshot-unit-types', property.id);
        }
    };


    if (isLoading || isFetching) {


        return (
            <Box sx={{
                display: 'flex',
                marginLeft: '48%',
                marginTop: '200px'
            }}>
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return 'Internal Error - Contact Technical Support';
    }

    return (
        <div style={styles.root}>
            <div style={{
                ...styles.header,
                display: 'flex',
                flexDirection: 'row',
                width: '99%'
            }}>
                <div style={styles.header}>
                    <Header as='h2' content='Unit Types' color='grey' />
                </div>
                <div>
                    <Button size='medium' style={{
                        backgroundColor: 'green'

                    }} variant='contained' onClick={() => handlerRunSnapshot(data[0])}>
                            Run SnapShot for this Property
                    </Button>
                    &nbsp; &nbsp; &nbsp;
                    <Button size='medium' style={{
                        backgroundColor: 'green'

                    }} variant='contained' onClick={() => props.history.push(
										`/unit-types/${props.match.params.property_id}/pricing`
                    )}>
                            Unit Type Pricing
                    </Button>
                </div>
            </div>
            <Table>
                <Table.Body>

                    <React.Fragment key={props.match.params.property_id}> <Table.Row>
                        <Table.Cell colSpan='2'>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={8}>
                                        <Header
                                            as='h5'
                                            textAlign='center'
                                            content={'Specials'}
                                        />

                                        <SpecialsTable
                                            specials={data[0].specials || []}
                                            setSpecialsModalOpen={setSpecialsModalOpen}
                                            setInitialValues={setInitialValues}
                                            propertyId={data[0].id}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={8}>
                                        <Header
                                            as='h5'
                                            textAlign='center'
                                            content={'Growth Rates'}
                                        />

                                        <GrowthRateTable
                                            growthRates={data[0].growthRates || []}
                                            setGRModalOpen={setGRModalOpen}
                                            setInitialValues={setInitialValues}
                                            propertyId={data[0].id}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width={8}>
                                        <Header
                                            as='h5'
                                            textAlign='center'
                                            content={'Summary Groupings'}
                                        />

                                        <GroupingsTable data={data[0]} />


                                    </Grid.Column>
                                    <Grid.Column width={8}>
                                        <Header
                                            as='h5'
                                            textAlign='center'
                                            content={'Unit Types'}
                                        />

                                        <UnitTypesTable
                                            allUnitTypesWithRate={data.allUnitTypesWithRate}
                                            setUnitTypesModalOpen={setUnitTypesModalOpen}
                                            setInitialValues={setInitialValues}
                                            propertyId={data[0].id}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Table.Cell>
                    </Table.Row>
                    </React.Fragment>
                </Table.Body>
            </Table>
            <Modal
                open={specialsModalOpen}
                onOpen={() => setSpecialsModalOpen(true)}
                children={
                    <SpecialsForm
                        closeModal={() => setSpecialsModalOpen(false)}
                        initialValues={initialValues}
                    />
                }
            />
            <Modal
                open={grModalOpen}
                onOpen={() => setGRModalOpen(true)}
                children={
                    <GrowthRateForm
                        closeModal={() => setGRModalOpen(false)}
                        initialValues={initialValues}
                        fetchMeasurements={fetchMeasurements}
                        allUnitTypesWithRate={data.allUnitTypesWithRate}
                    />
                }
            />
            <Modal
                open={unitTypesModalOpen}
                onOpen={() => setUnitTypesModalOpen(true)}
                children={
                    <UnitTypesForm
                        closeModal={() => setUnitTypesModalOpen(false)}
                        initialValues={initialValues}
                    />
                }
            />
        </div>
    );
};

export default UnitTypesView;
